/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UsersRouteImport } from './routes/users'
import { Route as RunsRouteImport } from './routes/runs'
import { Route as ReviewsRouteImport } from './routes/reviews'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as PromptsRouteImport } from './routes/prompts'
import { Route as PersonasRouteImport } from './routes/personas'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as LoginRouteImport } from './routes/login'
import { Route as KnowledgeRouteImport } from './routes/knowledge'
import { Route as IndexRouteImport } from './routes/index'

const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const RunsRoute = RunsRouteImport.update({
  id: '/runs',
  path: '/runs',
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewsRoute = ReviewsRouteImport.update({
  id: '/reviews',
  path: '/reviews',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const PromptsRoute = PromptsRouteImport.update({
  id: '/prompts',
  path: '/prompts',
  getParentRoute: () => rootRouteImport,
} as any)
const PersonasRoute = PersonasRouteImport.update({
  id: '/personas',
  path: '/personas',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const KnowledgeRoute = KnowledgeRouteImport.update({
  id: '/knowledge',
  path: '/knowledge',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/knowledge': typeof KnowledgeRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/personas': typeof PersonasRoute
  '/prompts': typeof PromptsRoute
  '/register': typeof RegisterRoute
  '/reviews': typeof ReviewsRoute
  '/runs': typeof RunsRoute
  '/users': typeof UsersRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/knowledge': typeof KnowledgeRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/personas': typeof PersonasRoute
  '/prompts': typeof PromptsRoute
  '/register': typeof RegisterRoute
  '/reviews': typeof ReviewsRoute
  '/runs': typeof RunsRoute
  '/users': typeof UsersRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/knowledge': typeof KnowledgeRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/personas': typeof PersonasRoute
  '/prompts': typeof PromptsRoute
  '/register': typeof RegisterRoute
  '/reviews': typeof ReviewsRoute
  '/runs': typeof RunsRoute
  '/users': typeof UsersRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/knowledge'
    | '/login'
    | '/onboarding'
    | '/personas'
    | '/prompts'
    | '/register'
    | '/reviews'
    | '/runs'
    | '/users'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/knowledge'
    | '/login'
    | '/onboarding'
    | '/personas'
    | '/prompts'
    | '/register'
    | '/reviews'
    | '/runs'
    | '/users'
  id:
    | '__root__'
    | '/'
    | '/knowledge'
    | '/login'
    | '/onboarding'
    | '/personas'
    | '/prompts'
    | '/register'
    | '/reviews'
    | '/runs'
    | '/users'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  KnowledgeRoute: typeof KnowledgeRoute
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRoute
  PersonasRoute: typeof PersonasRoute
  PromptsRoute: typeof PromptsRoute
  RegisterRoute: typeof RegisterRoute
  ReviewsRoute: typeof ReviewsRoute
  RunsRoute: typeof RunsRoute
  UsersRoute: typeof UsersRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/runs': {
      id: '/runs'
      path: '/runs'
      fullPath: '/runs'
      preLoaderRoute: typeof RunsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reviews': {
      id: '/reviews'
      path: '/reviews'
      fullPath: '/reviews'
      preLoaderRoute: typeof ReviewsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prompts': {
      id: '/prompts'
      path: '/prompts'
      fullPath: '/prompts'
      preLoaderRoute: typeof PromptsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/personas': {
      id: '/personas'
      path: '/personas'
      fullPath: '/personas'
      preLoaderRoute: typeof PersonasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/knowledge': {
      id: '/knowledge'
      path: '/knowledge'
      fullPath: '/knowledge'
      preLoaderRoute: typeof KnowledgeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  KnowledgeRoute: KnowledgeRoute,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
  PersonasRoute: PersonasRoute,
  PromptsRoute: PromptsRoute,
  RegisterRoute: RegisterRoute,
  ReviewsRoute: ReviewsRoute,
  RunsRoute: RunsRoute,
  UsersRoute: UsersRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
